(function(){
  const replacements = [
    [/\b(?:pan oxyl|panoxy|panoxl|panox|panocyl|panoply)\b/gi, 'PanOxyl'],
    [/\b(?:adaplene|adapalane)\b/gi, 'adapalene'],
    [/\b(?:differen|differing)\b/gi, 'Differin'],
    [/\b(?:benzol|benzoulyl) peroxide\b/gi, 'benzoyl peroxide'],
    [/\b(?:salycilic|salycylic) acid\b/gi, 'salicylic acid'],
    [/\bsulphur\b/gi, 'sulfur'],
    [/\bsimeticone\b/gi, 'simethicone'],
    [/\b(?:tsal|t sal)\b/gi, 'T/Sal'],
    [/\bcera ve\b/gi, 'CeraVe'],
    [/\bdelacruz\b/gi, 'De La Cruz'],
    [/\bderma harmony\b/gi, 'DermaHarmony'],
    [/\bacne free\b/gi, 'AcneFree']
  ];
  window.usaSearchTerm = function(value){
    if (/\b(?:id|title|vendor|tag|product_type):/i.test(value)) return value;
    return replacements.reduce(function(term,pair){return term.replace(pair[0],pair[1])},value).trim();
  };
  // These names must match the product title, not incidental ingredients in descriptions.
  window.usaPreciseSearch = function(value){
    const term=window.usaSearchTerm(value).trim();
    if(/^(?:neutrogena\s+)?t[\s/-]?sal(?:\s+shampoo)?$/i.test(term))return {label:'T/Sal',query:'title:"T/Sal"'};
    if(/^simethicone$/i.test(term))return {label:'simethicone',query:'title:simethicone'};
    return null;
  };
  function destination(value){
    const url=new URL('/search',location.origin);
    const term=window.usaSearchTerm(value), precise=window.usaPreciseSearch(term);
    url.searchParams.set('q',precise?precise.query:term);
    url.searchParams.set('type','product');
    url.searchParams.set('options[unavailable_products]','last');
    url.searchParams.set('options[prefix]','last');
    return url;
  }
  document.addEventListener('submit',function(event){
    const form=event.target;
    if(!(form instanceof HTMLFormElement)||form.closest('facet-filters-form'))return;
    const input=form.querySelector('input[name="q"]');
    if(!input||!/\/(?:a\/)?search\/?$/.test(new URL(form.action,location.href).pathname))return;
    if(form.querySelector('[aria-selected="true"] a'))return;
    event.preventDefault();event.stopImmediatePropagation();
    if(input.value.trim())location.assign(destination(input.value).href);
  },true);
  document.addEventListener('click',function(event){
    const link=event.target.closest('a[href]');if(!link)return;
    const url=new URL(link.href,location.origin);
    if(url.origin!==location.origin||!/^\/a\/search\/?$/.test(url.pathname))return;
    link.href=destination(url.searchParams.get('q')||'').href;
  },true);
  function init(){
    document.querySelectorAll('a[href^="/a/search?"]').forEach(link=>{const old=new URL(link.href);link.href=destination(old.searchParams.get('q')||'').href;});
    const current=new URL(location.href);
    if(!/^\/(?:a\/)?search\/?$/.test(current.pathname)||!current.searchParams.has('q'))return;
    const original=current.searchParams.get('q'),term=window.usaSearchTerm(original),precise=window.usaPreciseSearch(term);
    const query=precise?precise.query:term;
    if(current.pathname==='/a/search'||query!==original){current.pathname='/search';current.searchParams.set('q',query);current.searchParams.set('type','product');current.searchParams.delete('page');location.replace(current.href);}
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
})();
